import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { initializeIcons } from '@fluentui/react';
import WebChatEditor from './packages/webchatEditor/components/webChatEditor';


export class App extends React.Component<{botId: string, baseUrl: string, botName: string, documentationUrl: string, onSuccess: () => any,  onClose: () => any, onSave: (json: any) => any, onConfigureSip?: () => any}, any> {
  constructor(props: any) {
    super(props);
    initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/');
  }

  render() {
    return (
      <WebChatEditor botId={this.props.botId} baseUrl={this.props.baseUrl} botName={this.props.botName} documentationUrl={this.props.documentationUrl} onClose={this.props.onClose} onSave={this.props.onSave} onSuccess={this.props.onSuccess} onConfigureSip={this.props.onConfigureSip}/>
    );
  }
}

export default App;
